import * as rmd from 'material-ui';
import React from "react";
import TournamentPickerMulti from './TournamentPickerMulti';
import TournamentPicker from './TournamentPicker';
import _ from 'lodash';

class LLTPicker extends React.Component {

    constructor(props, context) {
        super(props, context);

        let type = props.leaguesType;
        try {
            var tournamentIds = JSON.parse(props.tournamentIds);
        } catch (e) {

        }

        if (!_.isEqual(tournamentIds.sort(), this.topLeagues.sort())) {
            type = 'custom';
        }

        this.state = {
            label: props.label || "",
            type,
            tournamentIds,
            countryTournamentIds: []
        }
    }

    topLeagues = [47, 87, 55, 54, 53, 42, 73];

    handleTypeChange = (e, index, type) => {
        switch (type) {
            case 'custom':
                this.setState({type, tournamentIds: [], countryTournamentIds: []});
                break;
            case 'top.country':
            case 'top':
                this.setState({
                    type,
                    tournamentIds: this.topLeagues,
                    countryTournamentIds: []
                });
                break;
        }
    };

    handleMultiPickerTournaments = ({tournamentIds}) => {
        this.setState({
            tournamentIds
        });
    };

    handleCountryTournamentsPicker = ({tournamentIds = []}) => {
        this.setState({
            countryTournamentIds: tournamentIds
        });
    };

    componentWillUpdate(nextProps, nextState) {
        let oldTournamentIds = _.union(this.state.tournamentIds, this.state.countryTournamentIds);
        let newTournamentIds = _.union(nextState.tournamentIds, nextState.countryTournamentIds);

        if (!_.isEqual(oldTournamentIds.sort(), newTournamentIds.sort())) {
            this.props.onChange({'tournamentIds': newTournamentIds});
        }
    }

    render() {
        let {label} = this.state;

        return (
            <div >
                <rmd.SelectField
                    maxHeight={200}
                    value={this.state.type}
                    floatingLabelText={label}
                    floatingLabelFixed={true}
                    onChange={this.handleTypeChange}
                >
                    {[
                        {
                            value: 'top',
                            text: 'Top leagues'
                        },
                        {
                            value: 'top.country',
                            text: 'Top leagues + Country'
                        },
                        {
                            value: 'custom',
                            text: 'Custom leagues'
                        }
                    ].map(option => {
                        return (
                            <rmd.MenuItem
                                key={option.value}
                                value={option.value}
                                primaryText={option.text}
                            />
                        )
                    })}
                </rmd.SelectField>

                <TournamentPickerMulti key={this.state.type} onChange={this.handleMultiPickerTournaments} tournamentIds={JSON.stringify(this.state.tournamentIds)} />

                {this.state.type == 'top.country' && <TournamentPicker onChange={this.handleCountryTournamentsPicker} multi={true} hideSeasonPicker={true}/>}
            </div>
        );
    }
}

export default LLTPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/LiveListTournamentsPicker.js
 **/